import { createGenericReducer } from "common/genericReducer";
import { CONFIG_RECEIVED, CONFIG_REQUESTED, CONFIG_REQUEST_FAILED } from "./configActions";

export const config = createGenericReducer(CONFIG_REQUESTED, CONFIG_RECEIVED, CONFIG_REQUEST_FAILED);
